import { Icon28GiftOutline } from '@vkontakte/icons';
import { Spacing, Text } from '@vkontakte/vkui';
import coverImageDark from 'img/paid-user-return/paid_user_return_dark.png';
import coverImageLight from 'img/paid-user-return/paid_user_return_light.png';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { openFastCheckout } from 'reactApp/modules/payment/payment.module';
import { initProducts } from 'reactApp/modules/products/products.module';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './PaidUserReturnModal.css';

export interface PaidUserReturnModalProps {
    onClose?(): void;
    onShow?(): void;
    onClick?(): void;
    discount: number;
    productId: string;
}

export function PaidUserReturnModal({ discount, productId, onClose, onShow, onClick }: PaidUserReturnModalProps) {
    const isDarkTheme = isDarkThemeModeEnabled();
    const coverImage = isDarkTheme ? coverImageDark : coverImageLight;
    const title = `У вас была подписка Mail Space\u00A0— её\u00A0можно вернуть со\u00A0скидкой\u00A0${discount}%`;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(initProducts());
    }, []);

    const onCloseAction = useCallback(() => {
        onClose?.();
    }, [onClose]);

    const onClickAction = useCallback(() => {
        onClick?.();
        dispatch(
            openFastCheckout({
                productId,
                paySource: 'modal_revert_paid_user',
            })
        );
    }, [onClick, dispatch, productId]);

    const onShowAction = useCallback(() => {
        onShow?.();
    }, [onShow]);

    const contentNode = useMemo(
        () => (
            <div className={styles.content}>
                <Spacing size={12} />
                <Text className={styles.text}>
                    Всё будет как раньше: много места, никакой рекламы в&nbsp;Почте и&nbsp;Облаке. Ещё и&nbsp;сэкономите{' '}
                </Text>
                <Spacing size={24} />
            </div>
        ),
        []
    );

    const discountNode = useMemo(
        () => (
            <div className={styles.discount}>
                <Icon28GiftOutline />-{discount}%
            </div>
        ),
        [discount]
    );

    return (
        <WhatsNewDialog
            buttonTheme="vk"
            dialogSize="tiny"
            qaId="paid-user-return-modal"
            isRebranding
            imageUrl={coverImage}
            imageAdditionalContent={discountNode}
            onClose={onCloseAction}
            onShow={onShowAction}
            onClick={onClickAction}
            className={styles.root}
            title={title}
            content={contentNode}
            primaryButtonText="Забрать 512 ГБ со скидкой"
        />
    );
}
